import React, { useState, useEffect } from 'react'
import { Table, Button, Input, Space, Modal , DatePicker} from 'antd'
import { EyeOutlined, SearchOutlined } from '@ant-design/icons'
import axios from 'axios'

import { toast } from 'react-toastify'
import {
  getDocumentPendingList,
  DocumentApproveReject,
  IMG_BASE_URL,
} from '../../../AllAPI/AdminAPI'
import * as XLSX from 'xlsx'

const DocumentAppPendingList = () => {
  const storedBranchId = sessionStorage.getItem('selected_branch')
  const BoardingYear = sessionStorage.getItem('BoardingYear')
  const adminId = sessionStorage.getItem('admin_id')

  const [data, setData] = useState([])
  const [searchText, setSearchText] = useState('')
  const [viewModalOpen, setViewModalOpen] = useState(false)
  const [selectedRecord, setSelectedRecord] = useState(null)
  const [confirmChecked, setConfirmChecked] = useState(false)
  const [loading, setLoading] = useState(false)


  // const [rejectModalOpen, setRejectModalOpen] = useState(false)
  const [rejectedReason, setRejectedReason] = useState('')
  const [selectedApproval, setSelectedApproval] = useState('')
  const [interviewDate1, setInterviewDate1] = useState(null)
  const [interviewDate2, setInterviewDate2] = useState(null)
  // const [approveLoading, setApproveLoading] = useState(false)


  useEffect(() => {
    fetchDocumentAppPendingList()
  }, [])

  const fetchDocumentAppPendingList = async () => {
    setLoading(true)
    try {
      const res = await axios.get(
        `${getDocumentPendingList}/${storedBranchId}/${BoardingYear}`,
      )

      // const formatted = res.data.map((item, index) => ({
      //   key: item.reg_id,
      //   index: index + 1,
      //   full_name: `${item.s_fname} ${item.s_mname} ${item.s_lname}`,
      //   whats_no: item.wh_mobile || '-',
      //   // hostel_pay_amount : item.payment?.hostel_pay_amount ?? '-',
       

      //   //  Correct date format (YYYY-MM-DD)
      //   hostel_pay_date: item.payment?.hostel_pay_date
      //     ? new Date(item.payment.hostel_pay_date).toISOString().split('T')[0]
      //     : '-',
      //   hostel_pay_mode:
      //     item.payment.hostel_pay_mode == 1
      //       ? 'Cash'
      //       : item.payment.hostel_pay_mode == 2
      //       ? 'UPI'
      //       : 'Online',
      //   full_data: item,
      // }))

      
      // setData(formatted)


      const formatted = res.data.map((item, index) => ({
        key: item.reg_id,
        index: index + 1,
        full_name: `${item.s_fname} ${item.s_mname} ${item.s_lname}`,
        whats_no: item.wh_mobile || "-",
        regPay_approval_date: item.regPay_approval_date || "-",
        full_data: item,
      }));

      setData(formatted);

      console.log(res.data);
    } catch (err) {
      toast.error('Failed to load approved list')
    } finally {
      setLoading(false) // 👉 Stop loader
    }
  }

  // --- SEARCH ---
  const filteredData = data.filter((item) => {
    const search = searchText.toLowerCase()

    return (
      (item.full_name ?? '').toLowerCase().includes(search) ||
      (item.whats_no ?? '').toString().includes(search)
    )
  })

  const columns = [
    { title: 'Sr No', dataIndex: 'index', width: 80 },
    { title: 'Full Name', dataIndex: 'full_name' },
    { title: 'WhatsApp No', dataIndex: 'whats_no' },
     { title: 'Reg Approve Date', dataIndex: 'regPay_approval_date' },
 
    {
      title: 'Actions',
      align: 'center',
      render: (_, record) => (
        <Space>
          <Button
            icon={<EyeOutlined />}
            size="small"
            onClick={() => {
              setSelectedRecord(record.full_data)
              setViewModalOpen(true)
            }}
          />
        </Space>
      ),
    },
  ]



  const handleApproval = async () => {
  if (!selectedRecord) return;

  if (!selectedApproval) {
        toast.warning('Please select Approve or Reject')
        return
  }

  const today = new Date().toISOString().split('T')[0]

  
  let approvalBody = {
      reg_id: Number(selectedRecord.reg_id),
      document_approval: Number(selectedApproval),
      admin_id: adminId,
    }

  // const body = {
  //   reg_id: parseInt(selectedRecord.reg_id),
  //   document_approval: 2,
  // };

   // APPROVE
    if (Number(selectedApproval) == 2) {
      if (!interviewDate1 || !interviewDate2) {
        toast.warning('Please select both interview dates.')
        return
      }

      approvalBody = {
        ...approvalBody,
        document_approval_date: today,
        interview_status: 1,
        interview_date1: interviewDate1.format('YYYY-MM-DD'),
        interview_date2: interviewDate2.format('YYYY-MM-DD'),
        admin_id: adminId,
      }
    }

    // REJECT
        if (Number(selectedApproval) == 3) {
          if (!rejectedReason.trim()) {
            toast.warning('Please enter rejection reason.')
            return
          }
    
          approvalBody = {
            ...approvalBody,
            reject_reason: rejectedReason,
            admin_id: adminId,
          }
        }
    

  try {
    setLoading(true);

    const res = await axios.post(DocumentApproveReject, approvalBody );

    if (res.data === "APPROVED") {
      toast.success("Document Approved Successfully");

      setViewModalOpen(false);
      setConfirmChecked(false);
      setSelectedApproval("");
      setRejectedReason("");
      setInterviewDate1(null);
      setInterviewDate2(null);

      fetchDocumentAppPendingList();
    }
    else if (res.data === "REJECTED") {
      toast.success("Document Rejected Successfully");

      setViewModalOpen(false);
      setConfirmChecked(false);
      setSelectedApproval("");
      setRejectedReason("");
      setInterviewDate1(null);
      setInterviewDate2(null);

      fetchDocumentAppPendingList();
    }
    else {
      toast.error("Operation failed");
    }
  } catch (err) {
    console.log(err);
    toast.error("Something went wrong");
  } finally {
    setLoading(false);
  }
};

  // const handleRejectSubmit = async () => {
  //   if (!selectedRecord) return

  //   const body = {
  //     reg_id: parseInt(selectedRecord.reg_id),
  //     hostelPay_approval: 3,
  //     reject_reason: rejectReason.trim(),
  //   }

  //   try {
  //     setLoading(true)
  //     const res = await axios.put(FeeApproveReject, body)

  //     toast.success('Application Rejected Successfully')

  //     // Reset all states
  //     setRejectModalOpen(false)
  //     setRejectReason('')
  //     setConfirmChecked(false)

  //     fetchFeeAppPendingList()
  //   } catch (err) {
  //     toast.error('Failed to reject application')
  //   } finally {
  //     setLoading(false)
  //   }
  // }



  // =======CSS==========
  
  
//   const handleRejectSubmit = async () => {
//   if (!selectedRecord) return;

//   const body = {
//     reg_id: parseInt(selectedRecord.reg_id),
//     document_approval: 3,
//     reject_reason: rejectReason.trim(),
//   };

//   try {
//     setLoading(true);

//     const res = await axios.post(DocumentApproveReject, body);

//     if (res.data === "REJECTED") {
//       toast.success("Document Rejected Successfully");

//       setRejectModalOpen(false);
//       setRejectedReason("");
//       setConfirmChecked(false);

//       fetchDocumentAppPendingList();
//     } else {
//       toast.error("Rejection failed");
//     }
//   } catch (err) {
//     console.log(err);
//     toast.error("Something went wrong");
//   } finally {
//     setLoading(false);
//   }
// };
  
  const labelCss = {
    fontWeight: '600',
  }
  const titleText = {
    fontWeight: '600',
    fontSize: '16px',
    color: '#235784',
  }

  const exportToExcel = () => {
    if (filteredData.length === 0) {
      toast.warning('No data available to export')
      return
    }

    const excelData = filteredData.map((item, index) => ({
      'Sr No': index + 1,
      'Full Name': item.full_name,
      'WhatsApp No': item.whats_no,
      'Status': "Pending"
    }))
    
    
    const worksheet = XLSX.utils.json_to_sheet(excelData)

    worksheet['!cols'] = [
      { wch: 8 },
      { wch: 35 },
      { wch: 18 },
      { wch: 20 },
      { wch: 15 },
      { wch: 15 },
    ]

    // const excelData = filteredData.map((item) => {
    //   const student = { ...item.full_data }

    //   // Flatten nested objects
    //   student.admin = student.admin?.username || ''
    //   student.documents = JSON.stringify(student.documents || {})

    //   return student
    // })

    const workbook = XLSX.utils.book_new()

    XLSX.utils.book_append_sheet(
      workbook,
      worksheet,
      'Hostel Fee Approval Pending',
    )

    XLSX.writeFile(workbook, 'Document_Approval_Pending_List.xlsx')
  }

  return (
    <div className="form-container mainContainer">
      <div className="row p-0 m-0 pb-5">
        <div className="col-12 col-md-2"></div>
        <div className="col-12 col-md-8">
          <div className="header-row">
            <h2 className="page-title">Document Approval Pending List</h2>
          </div>

          <div
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              marginBottom: '15px',
              flexWrap: 'wrap',
              gap: '10px',
            }}
          >
            <Button
              type="primary"
              onClick={exportToExcel}
              style={{
                backgroundColor: '#198754',
                borderColor: '#198754',
              }}
            >
              Export Excel
            </Button>
            <Input
              placeholder="Search..."
              prefix={<SearchOutlined />}
              value={searchText}
              onChange={(e) => setSearchText(e.target.value)}
              style={{ width: 250 }}
            />
          </div>

          <Table
            className="shadow"
            columns={columns}
            dataSource={filteredData}
            pagination={{ pageSize: 10 }}
            bordered
            loading={loading}
            scroll={{ x: 'max-content' }}
          />
        </div>
        <div className="col-12 col-md-2"></div>
      </div>

      {/* ---------- VIEW MODAL ---------- */}

      <Modal
        title={null}
        open={viewModalOpen}
        // onCancel={() => {
        //   setViewModalOpen(false)
        //   setConfirmChecked(false)
        // }}
        onCancel={()=>{
          setViewModalOpen(false);
          setConfirmChecked(false);
          setSelectedApproval("");
          setRejectedReason("");
          setInterviewDate1(null);
          setInterviewDate2(null);
        }}
        footer={null}
        width={980}
      >
        {selectedRecord && (
          <div className="py-4 px-md-4">
            {/* HEADER */}
            <h3
              style={{
                textAlign: 'center',
                marginBottom: '20px',
                color: '#235784',
              }}
            >
              Student Details
            </h3>

            <div
              className="border rounded shadow p-2 p-md-4"
              style={{ backgroundColor: '#f2f7fd' }}
            >
              {/* ========= PERSONAL INFORMATION ========== */}
              <h6 style={titleText}>- Personal Information :</h6>
              <div
                className="rounded mb-3 "
                style={{ border: '1px solid #d2d2d2ff', padding: '10px' }}
              >
                <div className="row mb-3">
                  <div className="col-12 col-md-3">
                    <img
                      src={`${IMG_BASE_URL}${selectedRecord.documents.s_pic}`}
                      alt="Profile Picture"
                      className="rounded-circle img-fluid rounded border"
                      style={{
                        width: '160px',
                        height: '160px',
                        objectFit: 'contain',
                        display: 'block',
                      }}
                    />
                  </div>
                  <div className="col-12 col-md-9">
                    <div className="row">
                      <div className="col-md-12 py-1">
                        <span style={labelCss}>Full Name:</span>
                        <br />
                        <span
                          style={{
                            backgroundColor: '#f8ff90',
                            padding: '2px 10px',
                            fontSize: '16px',
                          }}
                        >
                          {selectedRecord.s_fname} {selectedRecord.s_mname}{' '}
                          {selectedRecord.s_lname}
                        </span>
                      </div>
                      <div className="col-md-4 py-1">
                        <span style={labelCss}>Mobile:</span>
                        <br /> {selectedRecord.mobile}
                      </div>
                      <div className="col-md-4 py-1">
                        <span style={labelCss}>WhatsApp No:</span>
                        <br /> {selectedRecord.wh_mobile || '-'}
                      </div>
                      <div className="col-md-4 py-1">
                        <span style={labelCss}>Email:</span>
                        <br /> {selectedRecord.email}
                      </div>
                      <div className="col-md-8 py-1">
                        <span style={labelCss}>Address:</span>
                        <br /> {selectedRecord.address},{' '}
                        {selectedRecord.village}
                      </div>
                    </div>
                  </div>
                </div>
              </div>


              {/* ========= UPLOADED DOCUMENTS ========== */}
              <>
                <h6 style={titleText}>- Uploaded Documents :</h6>
                
                <div className="card shadow-sm p-4 mb-4">
                  <h5 className="mb-3" style={{ color: '#235784' }}>
                    Documents -
                  </h5>

                  <div className="row text-center">
                    {Object.entries({
                      'Aadhar Card': selectedRecord?.documents?.s_aadhar,
                      '10th / 12th Leaving Certificate':
                        selectedRecord?.documents?.cast_income_cert,
                      'Recommendation Letter':
                        selectedRecord?.documents?.recommendation_letter,
                      'College Admission Receipt':
                        selectedRecord?.documents?.clg_add_receipt,
                    }).map(([label, fileName]) => {
                      const imgSrc = fileName ? IMG_BASE_URL + fileName : null

                      return (
                        <div
                          className="col-12 col-md-6 col-lg-4 mb-3 mt-3 pb-4"
                          style={{ border: '1px solid #b8b8b8ff' }}
                          key={label}
                        >
                          <p className="fw-semibold mb-1">{label}</p>

                          {imgSrc ? (
                            fileName.toLowerCase().endsWith('.pdf') ? (
                              <iframe
                                src={imgSrc}
                                title={label}
                                width="100%"
                                height="300px"
                                style={{
                                  border: '1px solid #ccc',
                                  borderRadius: '6px',
                                }}
                              />
                            ) : (
                              <img
                                src={imgSrc}
                                alt={label}
                                className="img-fluid rounded border"
                                style={{
                                  width: '100%',
                                  objectFit: 'contain',
                                  display: 'block',
                                }}
                              />
                            )
                          ) : (
                            <p className="text-muted">No File</p>
                          )}

                          {imgSrc && fileName.toLowerCase().endsWith('.pdf') && (
                            <a
                              href={imgSrc}
                              target="_blank"
                              rel="noopener noreferrer"
                              className="btn btn-sm btn-primary mt-2"
                            >
                              Download PDF
                            </a>
                          )}
                        </div>
                      )
                    })}
                  </div>
                </div>
              </>
            </div>

            {/**-----------APPROVE/REJECT SECTION-----------------*/}

            <div className="mt-4 p-3">
              {/* Confirm Checkbox */}
              <div className="d-flex align-items-center mb-3">
                <input
                  type="checkbox"
                  className="form-check-input me-2"
                  style={{ border: '1px solid black' }}
                  checked={confirmChecked}
                  onChange={(e) => {
                    const checked = e.target.checked
                    setConfirmChecked(checked)

                    // Clear fields whenever checkbox value changes
                    setSelectedApproval('')
                    setRejectedReason('')
                    setInterviewDate1(null)
                    setInterviewDate2(null)
                  }}/>
                <label style={{ fontSize: '15px', fontWeight: '500' }}>
                  I confirm all details are checked and verified
                </label>
              </div>


               {/* Action */}
              <div className="mb-3">
                <label className="form-label fw-semibold">
                  Approval Status <span className="text-danger">*</span>
                </label>

                <select
                  className="form-select"
                  value={selectedApproval}
                  onChange={(e) => setSelectedApproval(e.target.value)}
                  disabled={!confirmChecked}
                >
                  <option value="">Select</option>
                  <option value={2}>Approve</option>
                  <option value={3}>Reject</option>
                </select>
              </div>

              {/* APPROVE UI */}
              {selectedApproval == 2 && (
                <div className="border rounded p-3 mb-3 bg-light">
                  <h6
                    className="mb-3"
                    style={{
                      fontWeight: 600,
                      color: '#235784',
                    }}
                  >
                    Interview Schedule
                  </h6>

                  <div className="row">
                    <div className="col-md-6 mb-3">
                      <label className="form-label fw-semibold">
                        Interview Date 1
                      </label>

                      <DatePicker
                        style={{ width: '100%' }}
                        format="DD-MM-YYYY"
                        size="large"
                        value={interviewDate1}
                        onChange={(date) => setInterviewDate1(date)}
                      />
                    </div>

                    <div className="col-md-6 mb-3">
                      <label className="form-label fw-semibold">
                        Interview Date 2
                      </label>

                      <DatePicker
                        style={{ width: '100%' }}
                        format="DD-MM-YYYY"
                        size="large"
                        value={interviewDate2}
                        onChange={(date) => setInterviewDate2(date)}
                      />
                    </div>
                  </div>
                </div>
              )}



               {/* REJECT UI */}
                {selectedApproval == 3 && (
                  <div className="border rounded p-3 mb-3 bg-light">
                    <h6
                      className="mb-3"
                      style={{
                        fontWeight: 600,
                        color: '#d32f2f',
                      }}
                    >
                      Rejection Details
                    </h6>
              
                    <label className="form-label fw-semibold">
                      Reason for Rejection
                    </label>
              
                    <Input.TextArea
                      rows={4}
                      value={rejectedReason}
                      placeholder="Enter rejection reason..."
                      onChange={(e) => setRejectedReason(e.target.value)}
                    />
                  </div>
                  )}


                  {/* Buttons */}
                              <div className="d-flex gap-3 mt-3">
                                <Button
                                  type="primary"
                                  disabled={!confirmChecked}
                                  loading={loading}
                                  onClick={() => handleApproval()}
                                >
                                  Submit
                                </Button>
                  
                                <Button
                                  danger
                                  disabled={!confirmChecked}
                                  // loading={rejectLoading}
                                  // onClick={() => {
                                  //   setViewModalOpen(false)
                                  //   setSelectedApproval('')
                                  //   setRejectedReason('')
                                  // }}
                                  onClick={()=>{
                                    setViewModalOpen(false);
                                    setConfirmChecked(false);
                                    setSelectedApproval("");
                                    setRejectedReason("");
                                    setInterviewDate1(null);
                                    setInterviewDate2(null);
                                  }}
                                >
                                  Cancel
                                </Button>
                              </div>


              {/* Buttons */}
              
            </div>
          </div>
        )}
      </Modal>


      {/* =================== REJECT REASON MODAL =================== */}
      {/* <Modal
        className="reject-reason-modal"
        title={false}
        open={rejectModalOpen}
        onCancel={() => {
          setRejectModalOpen(false)
          setRejectReason('')
        }}
        footer={null}
        centered
      >
        <div className="reject-modal-header">
          <h3>Enter Rejection Reason</h3>
        </div>

        <div className="reject-modal-body">
          <label className="reject-label">Reason for Rejection:</label>
          <textarea
            className="reject-textarea"
            rows={4}
            value={rejectReason}
            onChange={(e) => setRejectReason(e.target.value)}
            placeholder="Enter reason..."
          ></textarea>
        </div>

        <div className="reject-modal-footer">
          <Button
            danger
            type="primary"
            className="reject-submit-btn"
            disabled={!rejectReason.trim()}
            onClick={handleRejectSubmit}
          >
            Submit
          </Button>
        </div>
      </Modal> */}
    </div>
  )
}

export default DocumentAppPendingList;
